import React from 'react';
import { Edges } from '@react-three/drei';

export function buildSceneGraph({
  object,
  materials,
  hovered,
  selected,
  onPointerOver,
  onPointerOut,
  onClick,
}) {
  if (object.isMesh) {
    const nodeName = object.name;

    const originalRot = [object.rotation.x, object.rotation.y, object.rotation.z];
    const finalRotation =
      nodeName.includes('VOLTMETER_SELECTOR_SWITCH') && selected.includes(nodeName)
        ? [originalRot[0], originalRot[1] + Math.PI / 2, originalRot[2]]
        : originalRot;

    const isSelected = selected.includes(nodeName);
    const isHovered = hovered === nodeName;

    return (
      <group
        key={nodeName}
        position={object.position}
        rotation={finalRotation}
        scale={object.scale}
      >
        <mesh
          geometry={object.geometry}
          material={materials[nodeName] || object.material}
          onPointerOver={(e) => onPointerOver(e, nodeName)}
          onPointerOut={(e) => onPointerOut(e)}
          onClick={(e) => onClick(e, nodeName)}
        />
        {(isSelected || isHovered) && (
          <Edges
            geometry={object.geometry}
            color={isSelected ? 'white' : '#4F86F7'}
            lineWidth={2}
          />
        )}
      </group>
    );
  }

  return (
    <group
      key={object.uuid}
      position={object.position}
      rotation={object.rotation}
      scale={object.scale}
    >
      {object.children.map((child) =>
        buildSceneGraph({
          object: child,
          materials,
          hovered,
          selected,
          onPointerOver,
          onPointerOut,
          onClick,
        })
      )}
    </group>
  );
}
